import { default as PromoCode } from './PromoCode/PromoCode';
export default PromoCode;
